import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CompanyPageContentDynamicZoneInput: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  HomepageContentDynamicZoneInput: any;
  /** A string used to identify an i18n locale */
  I18NLocaleCode: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  PageContentDynamicZoneInput: any;
  QuestionAnswerDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type Brand = {
  __typename?: 'Brand';
  createdAt?: Maybe<Scalars['DateTime']>;
  ctaColor?: Maybe<Scalars['String']>;
  favicon: UploadFileEntityResponse;
  homeLogo?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<BrandRelationResponseCollection>;
  logo: UploadFileEntityResponse;
  seo: ComponentMainSeo;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BrandEntity = {
  __typename?: 'BrandEntity';
  attributes?: Maybe<Brand>;
  id?: Maybe<Scalars['ID']>;
};

export type BrandEntityResponse = {
  __typename?: 'BrandEntityResponse';
  data?: Maybe<BrandEntity>;
};

export type BrandInput = {
  ctaColor?: InputMaybe<Scalars['String']>;
  favicon?: InputMaybe<Scalars['ID']>;
  homeLogo?: InputMaybe<Scalars['ID']>;
  logo?: InputMaybe<Scalars['ID']>;
  seo?: InputMaybe<ComponentMainSeoInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BrandRelationResponseCollection = {
  __typename?: 'BrandRelationResponseCollection';
  data: Array<BrandEntity>;
};

export type Company = {
  __typename?: 'Company';
  address: ComponentMainAddress;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<CompanyRelationResponseCollection>;
  logo?: Maybe<UploadFileEntityResponse>;
  name: Scalars['String'];
  offerConfirmationEmailTemplate?: Maybe<Scalars['String']>;
  offers?: Maybe<OfferRelationResponseCollection>;
  page?: Maybe<CompanyPageEntityResponse>;
  phone?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  whiteLogo?: Maybe<UploadFileEntityResponse>;
};


export type CompanyLocalizationsArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CompanyOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  attributes?: Maybe<Company>;
  id?: Maybe<Scalars['ID']>;
};

export type CompanyEntityResponse = {
  __typename?: 'CompanyEntityResponse';
  data?: Maybe<CompanyEntity>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  data: Array<CompanyEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyFiltersInput = {
  address?: InputMaybe<ComponentMainAddressFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CompanyFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFiltersInput>;
  offerConfirmationEmailTemplate?: InputMaybe<StringFilterInput>;
  offers?: InputMaybe<OfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  page?: InputMaybe<CompanyPageFiltersInput>;
  phone?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CompanyInput = {
  address?: InputMaybe<ComponentMainAddressInput>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  offerConfirmationEmailTemplate?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  whiteLogo?: InputMaybe<Scalars['ID']>;
};

export type CompanyPage = {
  __typename?: 'CompanyPage';
  company?: Maybe<CompanyEntityResponse>;
  content?: Maybe<Array<Maybe<CompanyPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  heroImage: UploadFileEntityResponse;
  leadText?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<CompanyPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo: ComponentMainSeo;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CompanyPageLocalizationsArgs = {
  filters?: InputMaybe<CompanyPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CompanyPageContentDynamicZone = ComponentMainAdvantages | ComponentMainAttributes | ComponentMainImageTextRow | ComponentMainText | Error;

export type CompanyPageEntity = {
  __typename?: 'CompanyPageEntity';
  attributes?: Maybe<CompanyPage>;
  id?: Maybe<Scalars['ID']>;
};

export type CompanyPageEntityResponse = {
  __typename?: 'CompanyPageEntityResponse';
  data?: Maybe<CompanyPageEntity>;
};

export type CompanyPageEntityResponseCollection = {
  __typename?: 'CompanyPageEntityResponseCollection';
  data: Array<CompanyPageEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompanyPageFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  leadText?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CompanyPageFiltersInput>;
  not?: InputMaybe<CompanyPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentMainSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CompanyPageInput = {
  company?: InputMaybe<Scalars['ID']>;
  content?: InputMaybe<Array<Scalars['CompanyPageContentDynamicZoneInput']>>;
  heroImage?: InputMaybe<Scalars['ID']>;
  leadText?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<ComponentMainSeoInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CompanyPageRelationResponseCollection = {
  __typename?: 'CompanyPageRelationResponseCollection';
  data: Array<CompanyPageEntity>;
};

export type CompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection';
  data: Array<CompanyEntity>;
};

export type ComponentAnswerAnswerOption = {
  __typename?: 'ComponentAnswerAnswerOption';
  answer: Scalars['String'];
  id: Scalars['ID'];
  preferred?: Maybe<Scalars['Boolean']>;
};

export type ComponentAnswerAnswerOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentAnswerAnswerOptionFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentAnswerAnswerOptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentAnswerAnswerOptionFiltersInput>>>;
  preferred?: InputMaybe<BooleanFilterInput>;
};

export type ComponentAnswerFreeText = {
  __typename?: 'ComponentAnswerFreeText';
  id: Scalars['ID'];
  required?: Maybe<Scalars['Boolean']>;
};

export type ComponentAnswerMultipleChoice = {
  __typename?: 'ComponentAnswerMultipleChoice';
  id: Scalars['ID'];
  onlyOneAnswer?: Maybe<Scalars['Boolean']>;
  options: Array<Maybe<ComponentAnswerAnswerOption>>;
};


export type ComponentAnswerMultipleChoiceOptionsArgs = {
  filters?: InputMaybe<ComponentAnswerAnswerOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentAnswerYesNo = {
  __typename?: 'ComponentAnswerYesNo';
  id: Scalars['ID'];
  preferred?: Maybe<Enum_Componentansweryesno_Preferred>;
};

export type ComponentMainAccordion = {
  __typename?: 'ComponentMainAccordion';
  id: Scalars['ID'];
  items: Array<Maybe<ComponentMainAccordionItem>>;
};


export type ComponentMainAccordionItemsArgs = {
  filters?: InputMaybe<ComponentMainAccordionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentMainAccordionItem = {
  __typename?: 'ComponentMainAccordionItem';
  id: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentMainAccordionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainAccordionItemFiltersInput>>>;
  not?: InputMaybe<ComponentMainAccordionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainAccordionItemFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMainAddress = {
  __typename?: 'ComponentMainAddress';
  country: Enum_Componentmainaddress_Country;
  id: Scalars['ID'];
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  street: Scalars['String'];
};

export type ComponentMainAddressFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainAddressFiltersInput>>>;
  country?: InputMaybe<StringFilterInput>;
  locality?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainAddressFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainAddressFiltersInput>>>;
  postalCode?: InputMaybe<StringFilterInput>;
  region?: InputMaybe<StringFilterInput>;
  street?: InputMaybe<StringFilterInput>;
};

export type ComponentMainAddressInput = {
  country?: InputMaybe<Enum_Componentmainaddress_Country>;
  id?: InputMaybe<Scalars['ID']>;
  locality?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ComponentMainAdvantageItem = {
  __typename?: 'ComponentMainAdvantageItem';
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
};

export type ComponentMainAdvantageItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainAdvantageItemFiltersInput>>>;
  not?: InputMaybe<ComponentMainAdvantageItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainAdvantageItemFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentMainAdvantages = {
  __typename?: 'ComponentMainAdvantages';
  elements?: Maybe<Array<Maybe<ComponentMainAdvantageItem>>>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};


export type ComponentMainAdvantagesElementsArgs = {
  filters?: InputMaybe<ComponentMainAdvantageItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentMainAttributeItem = {
  __typename?: 'ComponentMainAttributeItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ComponentMainAttributeItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainAttributeItemFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainAttributeItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainAttributeItemFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentMainAttributes = {
  __typename?: 'ComponentMainAttributes';
  id: Scalars['ID'];
  items: Array<Maybe<ComponentMainAttributeItem>>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentMainAttributesItemsArgs = {
  filters?: InputMaybe<ComponentMainAttributeItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentMainBenefit = {
  __typename?: 'ComponentMainBenefit';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type ComponentMainBenefitFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainBenefitFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainBenefitFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainBenefitFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentMainBenefitInput = {
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ComponentMainContactPerson = {
  __typename?: 'ComponentMainContactPerson';
  additional?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type ComponentMainContactPersonFiltersInput = {
  additional?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMainContactPersonFiltersInput>>>;
  email?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainContactPersonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainContactPersonFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  position?: InputMaybe<StringFilterInput>;
};

export type ComponentMainContactPersonInput = {
  additional?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

export type ComponentMainCoordinates = {
  __typename?: 'ComponentMainCoordinates';
  id: Scalars['ID'];
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type ComponentMainCoordinatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainCoordinatesFiltersInput>>>;
  lat?: InputMaybe<FloatFilterInput>;
  long?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<ComponentMainCoordinatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainCoordinatesFiltersInput>>>;
};

export type ComponentMainCoordinatesInput = {
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
};

export type ComponentMainImageTextRow = {
  __typename?: 'ComponentMainImageTextRow';
  id: Scalars['ID'];
  image: UploadFileEntityResponse;
  link?: Maybe<ComponentMainLink>;
  rating?: Maybe<Array<Maybe<ComponentMainRating>>>;
  reversed?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentMainImageTextRowRatingArgs = {
  filters?: InputMaybe<ComponentMainRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentMainLink = {
  __typename?: 'ComponentMainLink';
  external?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ComponentMainLocation = {
  __typename?: 'ComponentMainLocation';
  address?: Maybe<ComponentMainAddress>;
  coordinates?: Maybe<ComponentMainCoordinates>;
  id: Scalars['ID'];
};

export type ComponentMainLocationFiltersInput = {
  address?: InputMaybe<ComponentMainAddressFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMainLocationFiltersInput>>>;
  coordinates?: InputMaybe<ComponentMainCoordinatesFiltersInput>;
  not?: InputMaybe<ComponentMainLocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainLocationFiltersInput>>>;
};

export type ComponentMainLocationInput = {
  address?: InputMaybe<ComponentMainAddressInput>;
  coordinates?: InputMaybe<ComponentMainCoordinatesInput>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ComponentMainRating = {
  __typename?: 'ComponentMainRating';
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type ComponentMainRatingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainRatingFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainRatingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainRatingFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  value?: InputMaybe<FloatFilterInput>;
};

export type ComponentMainScript = {
  __typename?: 'ComponentMainScript';
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentMainSeo = {
  __typename?: 'ComponentMainSeo';
  id: Scalars['ID'];
  keywords?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle: Scalars['String'];
  preventIndexing?: Maybe<Scalars['Boolean']>;
  sharedImage: ComponentMainSharedImage;
};

export type ComponentMainSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainSeoFiltersInput>>>;
  keywords?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMainSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainSeoFiltersInput>>>;
  preventIndexing?: InputMaybe<BooleanFilterInput>;
  sharedImage?: InputMaybe<ComponentMainSharedImageFiltersInput>;
};

export type ComponentMainSeoInput = {
  id?: InputMaybe<Scalars['ID']>;
  keywords?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaTitle?: InputMaybe<Scalars['String']>;
  preventIndexing?: InputMaybe<Scalars['Boolean']>;
  sharedImage?: InputMaybe<ComponentMainSharedImageInput>;
};

export type ComponentMainSharedImage = {
  __typename?: 'ComponentMainSharedImage';
  alt: Scalars['String'];
  id: Scalars['ID'];
  media: UploadFileEntityResponse;
};

export type ComponentMainSharedImageFiltersInput = {
  alt?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMainSharedImageFiltersInput>>>;
  not?: InputMaybe<ComponentMainSharedImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainSharedImageFiltersInput>>>;
};

export type ComponentMainSharedImageInput = {
  alt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Scalars['ID']>;
};

export type ComponentMainText = {
  __typename?: 'ComponentMainText';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export enum Enum_Componentansweryesno_Preferred {
  No = 'no',
  None = 'none',
  Yes = 'yes'
}

export enum Enum_Componentmainaddress_Country {
  De = 'DE',
  Nl = 'NL'
}

export enum Enum_Offer_Remote {
  Full = 'full',
  Half = 'half',
  Not = 'not'
}

export enum Enum_Place_Type {
  City = 'city',
  Island = 'island',
  Sea = 'sea'
}

export enum Enum_Tag_Color {
  Blue = 'blue',
  Cyan = 'cyan',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export enum Enum_Tag_Icon {
  Calendar = 'calendar',
  Education = 'education',
  Money = 'money',
  Time = 'time'
}

export type EmploymentTime = {
  __typename?: 'EmploymentTime';
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<EmploymentTimeRelationResponseCollection>;
  name: Scalars['String'];
  offers?: Maybe<OfferRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EmploymentTimeLocalizationsArgs = {
  filters?: InputMaybe<EmploymentTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type EmploymentTimeOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EmploymentTimeEntity = {
  __typename?: 'EmploymentTimeEntity';
  attributes?: Maybe<EmploymentTime>;
  id?: Maybe<Scalars['ID']>;
};

export type EmploymentTimeEntityResponse = {
  __typename?: 'EmploymentTimeEntityResponse';
  data?: Maybe<EmploymentTimeEntity>;
};

export type EmploymentTimeEntityResponseCollection = {
  __typename?: 'EmploymentTimeEntityResponseCollection';
  data: Array<EmploymentTimeEntity>;
  meta: ResponseCollectionMeta;
};

export type EmploymentTimeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmploymentTimeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EmploymentTimeFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmploymentTimeFiltersInput>;
  offers?: InputMaybe<OfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmploymentTimeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmploymentTimeInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EmploymentTimeRelationResponseCollection = {
  __typename?: 'EmploymentTimeRelationResponseCollection';
  data: Array<EmploymentTimeEntity>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type FieldOfActivity = {
  __typename?: 'FieldOfActivity';
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<FieldOfActivityRelationResponseCollection>;
  name: Scalars['String'];
  offers?: Maybe<OfferRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type FieldOfActivityLocalizationsArgs = {
  filters?: InputMaybe<FieldOfActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type FieldOfActivityOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FieldOfActivityEntity = {
  __typename?: 'FieldOfActivityEntity';
  attributes?: Maybe<FieldOfActivity>;
  id?: Maybe<Scalars['ID']>;
};

export type FieldOfActivityEntityResponse = {
  __typename?: 'FieldOfActivityEntityResponse';
  data?: Maybe<FieldOfActivityEntity>;
};

export type FieldOfActivityEntityResponseCollection = {
  __typename?: 'FieldOfActivityEntityResponseCollection';
  data: Array<FieldOfActivityEntity>;
  meta: ResponseCollectionMeta;
};

export type FieldOfActivityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FieldOfActivityFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<FieldOfActivityFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<FieldOfActivityFiltersInput>;
  offers?: InputMaybe<OfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FieldOfActivityFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FieldOfActivityInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FieldOfActivityRelationResponseCollection = {
  __typename?: 'FieldOfActivityRelationResponseCollection';
  data: Array<FieldOfActivityEntity>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = Brand | Company | CompanyPage | ComponentAnswerAnswerOption | ComponentAnswerFreeText | ComponentAnswerMultipleChoice | ComponentAnswerYesNo | ComponentMainAccordion | ComponentMainAccordionItem | ComponentMainAddress | ComponentMainAdvantageItem | ComponentMainAdvantages | ComponentMainAttributeItem | ComponentMainAttributes | ComponentMainBenefit | ComponentMainContactPerson | ComponentMainCoordinates | ComponentMainImageTextRow | ComponentMainLink | ComponentMainLocation | ComponentMainRating | ComponentMainScript | ComponentMainSeo | ComponentMainSharedImage | ComponentMainText | EmploymentTime | FieldOfActivity | Homepage | I18NLocale | Offer | Page | Place | Question | Tag | TypeOfEmployment | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Homepage = {
  __typename?: 'Homepage';
  content?: Maybe<Array<Maybe<HomepageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  heroImage: UploadFileEntityResponse;
  leadText?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<HomepageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type HomepageLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type HomepageContentDynamicZone = ComponentMainAdvantages | ComponentMainAttributes | ComponentMainImageTextRow | ComponentMainText | Error;

export type HomepageEntity = {
  __typename?: 'HomepageEntity';
  attributes?: Maybe<Homepage>;
  id?: Maybe<Scalars['ID']>;
};

export type HomepageEntityResponse = {
  __typename?: 'HomepageEntityResponse';
  data?: Maybe<HomepageEntity>;
};

export type HomepageInput = {
  content?: InputMaybe<Array<Scalars['HomepageContentDynamicZoneInput']>>;
  heroImage?: InputMaybe<Scalars['ID']>;
  leadText?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type HomepageRelationResponseCollection = {
  __typename?: 'HomepageRelationResponseCollection';
  data: Array<HomepageEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createBrandLocalization?: Maybe<BrandEntityResponse>;
  createCompany?: Maybe<CompanyEntityResponse>;
  createCompanyLocalization?: Maybe<CompanyEntityResponse>;
  createCompanyPage?: Maybe<CompanyPageEntityResponse>;
  createCompanyPageLocalization?: Maybe<CompanyPageEntityResponse>;
  createEmploymentTime?: Maybe<EmploymentTimeEntityResponse>;
  createEmploymentTimeLocalization?: Maybe<EmploymentTimeEntityResponse>;
  createFieldOfActivity?: Maybe<FieldOfActivityEntityResponse>;
  createFieldOfActivityLocalization?: Maybe<FieldOfActivityEntityResponse>;
  createHomepageLocalization?: Maybe<HomepageEntityResponse>;
  createOffer?: Maybe<OfferEntityResponse>;
  createOfferLocalization?: Maybe<OfferEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createPageLocalization?: Maybe<PageEntityResponse>;
  createPlace?: Maybe<PlaceEntityResponse>;
  createQuestion?: Maybe<QuestionEntityResponse>;
  createQuestionLocalization?: Maybe<QuestionEntityResponse>;
  createTag?: Maybe<TagEntityResponse>;
  createTagLocalization?: Maybe<TagEntityResponse>;
  createTypeOfEmployment?: Maybe<TypeOfEmploymentEntityResponse>;
  createTypeOfEmploymentLocalization?: Maybe<TypeOfEmploymentEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteBrand?: Maybe<BrandEntityResponse>;
  deleteCompany?: Maybe<CompanyEntityResponse>;
  deleteCompanyPage?: Maybe<CompanyPageEntityResponse>;
  deleteEmploymentTime?: Maybe<EmploymentTimeEntityResponse>;
  deleteFieldOfActivity?: Maybe<FieldOfActivityEntityResponse>;
  deleteHomepage?: Maybe<HomepageEntityResponse>;
  deleteOffer?: Maybe<OfferEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deletePlace?: Maybe<PlaceEntityResponse>;
  deleteQuestion?: Maybe<QuestionEntityResponse>;
  deleteTag?: Maybe<TagEntityResponse>;
  deleteTypeOfEmployment?: Maybe<TypeOfEmploymentEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateBrand?: Maybe<BrandEntityResponse>;
  updateCompany?: Maybe<CompanyEntityResponse>;
  updateCompanyPage?: Maybe<CompanyPageEntityResponse>;
  updateEmploymentTime?: Maybe<EmploymentTimeEntityResponse>;
  updateFieldOfActivity?: Maybe<FieldOfActivityEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateHomepage?: Maybe<HomepageEntityResponse>;
  updateOffer?: Maybe<OfferEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updatePlace?: Maybe<PlaceEntityResponse>;
  updateQuestion?: Maybe<QuestionEntityResponse>;
  updateTag?: Maybe<TagEntityResponse>;
  updateTypeOfEmployment?: Maybe<TypeOfEmploymentEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateBrandLocalizationArgs = {
  data?: InputMaybe<BrandInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCompanyLocalizationArgs = {
  data?: InputMaybe<CompanyInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCompanyPageArgs = {
  data: CompanyPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCompanyPageLocalizationArgs = {
  data?: InputMaybe<CompanyPageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateEmploymentTimeArgs = {
  data: EmploymentTimeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateEmploymentTimeLocalizationArgs = {
  data?: InputMaybe<EmploymentTimeInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateFieldOfActivityArgs = {
  data: FieldOfActivityInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateFieldOfActivityLocalizationArgs = {
  data?: InputMaybe<FieldOfActivityInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateHomepageLocalizationArgs = {
  data?: InputMaybe<HomepageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateOfferArgs = {
  data: OfferInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateOfferLocalizationArgs = {
  data?: InputMaybe<OfferInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageArgs = {
  data: PageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageLocalizationArgs = {
  data?: InputMaybe<PageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePlaceArgs = {
  data: PlaceInput;
};


export type MutationCreateQuestionArgs = {
  data: QuestionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateQuestionLocalizationArgs = {
  data?: InputMaybe<QuestionInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTagArgs = {
  data: TagInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTagLocalizationArgs = {
  data?: InputMaybe<TagInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTypeOfEmploymentArgs = {
  data: TypeOfEmploymentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTypeOfEmploymentLocalizationArgs = {
  data?: InputMaybe<TypeOfEmploymentInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteBrandArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteCompanyPageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteEmploymentTimeArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteFieldOfActivityArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteOfferArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePlaceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTypeOfEmploymentArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateBrandArgs = {
  data: BrandInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateCompanyArgs = {
  data: CompanyInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateCompanyPageArgs = {
  data: CompanyPageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateEmploymentTimeArgs = {
  data: EmploymentTimeInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateFieldOfActivityArgs = {
  data: FieldOfActivityInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateHomepageArgs = {
  data: HomepageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateOfferArgs = {
  data: OfferInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePlaceArgs = {
  data: PlaceInput;
  id: Scalars['ID'];
};


export type MutationUpdateQuestionArgs = {
  data: QuestionInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTagArgs = {
  data: TagInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTypeOfEmploymentArgs = {
  data: TypeOfEmploymentInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type Offer = {
  __typename?: 'Offer';
  benefits?: Maybe<Array<Maybe<ComponentMainBenefit>>>;
  company?: Maybe<CompanyEntityResponse>;
  contactPerson: ComponentMainContactPerson;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employment_times?: Maybe<EmploymentTimeRelationResponseCollection>;
  field_of_activities?: Maybe<FieldOfActivityRelationResponseCollection>;
  images?: Maybe<UploadFileRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<OfferRelationResponseCollection>;
  location?: Maybe<ComponentMainLocation>;
  mainImage?: Maybe<UploadFileEntityResponse>;
  place?: Maybe<PlaceEntityResponse>;
  priority?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  questions?: Maybe<QuestionRelationResponseCollection>;
  relatedOffers?: Maybe<OfferRelationResponseCollection>;
  remote?: Maybe<Enum_Offer_Remote>;
  seo: ComponentMainSeo;
  short_description?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<TagRelationResponseCollection>;
  title: Scalars['String'];
  type_of_employments?: Maybe<TypeOfEmploymentRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  video?: Maybe<UploadFileEntityResponse>;
  videoURL?: Maybe<Scalars['String']>;
  withoutCV?: Maybe<Scalars['Boolean']>;
};


export type OfferBenefitsArgs = {
  filters?: InputMaybe<ComponentMainBenefitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferEmployment_TimesArgs = {
  filters?: InputMaybe<EmploymentTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferField_Of_ActivitiesArgs = {
  filters?: InputMaybe<FieldOfActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferLocalizationsArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferRelatedOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferTagsArgs = {
  filters?: InputMaybe<TagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OfferType_Of_EmploymentsArgs = {
  filters?: InputMaybe<TypeOfEmploymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OfferEntity = {
  __typename?: 'OfferEntity';
  attributes?: Maybe<Offer>;
  id?: Maybe<Scalars['ID']>;
};

export type OfferEntityResponse = {
  __typename?: 'OfferEntityResponse';
  data?: Maybe<OfferEntity>;
};

export type OfferEntityResponseCollection = {
  __typename?: 'OfferEntityResponseCollection';
  data: Array<OfferEntity>;
  meta: ResponseCollectionMeta;
};

export type OfferFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<OfferFiltersInput>>>;
  benefits?: InputMaybe<ComponentMainBenefitFiltersInput>;
  company?: InputMaybe<CompanyFiltersInput>;
  contactPerson?: InputMaybe<ComponentMainContactPersonFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  employment_times?: InputMaybe<EmploymentTimeFiltersInput>;
  field_of_activities?: InputMaybe<FieldOfActivityFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<OfferFiltersInput>;
  location?: InputMaybe<ComponentMainLocationFiltersInput>;
  not?: InputMaybe<OfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<OfferFiltersInput>>>;
  place?: InputMaybe<PlaceFiltersInput>;
  priority?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  questions?: InputMaybe<QuestionFiltersInput>;
  relatedOffers?: InputMaybe<OfferFiltersInput>;
  remote?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentMainSeoFiltersInput>;
  short_description?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<TagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type_of_employments?: InputMaybe<TypeOfEmploymentFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  videoURL?: InputMaybe<StringFilterInput>;
  withoutCV?: InputMaybe<BooleanFilterInput>;
};

export type OfferInput = {
  benefits?: InputMaybe<Array<InputMaybe<ComponentMainBenefitInput>>>;
  company?: InputMaybe<Scalars['ID']>;
  contactPerson?: InputMaybe<ComponentMainContactPersonInput>;
  description?: InputMaybe<Scalars['String']>;
  employment_times?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  field_of_activities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location?: InputMaybe<ComponentMainLocationInput>;
  mainImage?: InputMaybe<Scalars['ID']>;
  place?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['Float']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  relatedOffers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  remote?: InputMaybe<Enum_Offer_Remote>;
  seo?: InputMaybe<ComponentMainSeoInput>;
  short_description?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
  type_of_employments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  video?: InputMaybe<Scalars['ID']>;
  videoURL?: InputMaybe<Scalars['String']>;
  withoutCV?: InputMaybe<Scalars['Boolean']>;
};

export type OfferRelationResponseCollection = {
  __typename?: 'OfferRelationResponseCollection';
  data: Array<OfferEntity>;
};

export type Page = {
  __typename?: 'Page';
  content: Array<Maybe<PageContentDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<UploadFileEntityResponse>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  withFooterLink?: Maybe<Scalars['Boolean']>;
};


export type PageLocalizationsArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageContentDynamicZone = ComponentMainAccordion | ComponentMainScript | ComponentMainText | Error;

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  withFooterLink?: InputMaybe<BooleanFilterInput>;
};

export type PageInput = {
  content?: InputMaybe<Array<Scalars['PageContentDynamicZoneInput']>>;
  image?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  withFooterLink?: InputMaybe<Scalars['Boolean']>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<PageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type Place = {
  __typename?: 'Place';
  coordinates?: Maybe<ComponentMainCoordinates>;
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Enum_Place_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PlaceEntity = {
  __typename?: 'PlaceEntity';
  attributes?: Maybe<Place>;
  id?: Maybe<Scalars['ID']>;
};

export type PlaceEntityResponse = {
  __typename?: 'PlaceEntityResponse';
  data?: Maybe<PlaceEntity>;
};

export type PlaceEntityResponseCollection = {
  __typename?: 'PlaceEntityResponseCollection';
  data: Array<PlaceEntity>;
  meta: ResponseCollectionMeta;
};

export type PlaceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PlaceFiltersInput>>>;
  coordinates?: InputMaybe<ComponentMainCoordinatesFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PlaceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PlaceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PlaceInput = {
  coordinates?: InputMaybe<ComponentMainCoordinatesInput>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Enum_Place_Type>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  brand?: Maybe<BrandEntityResponse>;
  companies?: Maybe<CompanyEntityResponseCollection>;
  company?: Maybe<CompanyEntityResponse>;
  companyPage?: Maybe<CompanyPageEntityResponse>;
  companyPages?: Maybe<CompanyPageEntityResponseCollection>;
  employmentTime?: Maybe<EmploymentTimeEntityResponse>;
  employmentTimes?: Maybe<EmploymentTimeEntityResponseCollection>;
  fieldOfActivities?: Maybe<FieldOfActivityEntityResponseCollection>;
  fieldOfActivity?: Maybe<FieldOfActivityEntityResponse>;
  homepage?: Maybe<HomepageEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  offer?: Maybe<OfferEntityResponse>;
  offers?: Maybe<OfferEntityResponseCollection>;
  /** Return the count of offers */
  offersCount: Scalars['Int'];
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  place?: Maybe<PlaceEntityResponse>;
  places?: Maybe<PlaceEntityResponseCollection>;
  question?: Maybe<QuestionEntityResponse>;
  questions?: Maybe<QuestionEntityResponseCollection>;
  tag?: Maybe<TagEntityResponse>;
  tags?: Maybe<TagEntityResponseCollection>;
  typeOfEmployment?: Maybe<TypeOfEmploymentEntityResponse>;
  typeOfEmployments?: Maybe<TypeOfEmploymentEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryBrandArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryCompanyPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryCompanyPagesArgs = {
  filters?: InputMaybe<CompanyPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEmploymentTimeArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryEmploymentTimesArgs = {
  filters?: InputMaybe<EmploymentTimeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFieldOfActivitiesArgs = {
  filters?: InputMaybe<FieldOfActivityFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFieldOfActivityArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOfferArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOffersCountArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPlaceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPlacesArgs = {
  filters?: InputMaybe<PlaceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryQuestionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTagArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryTagsArgs = {
  filters?: InputMaybe<TagFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTypeOfEmploymentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryTypeOfEmploymentsArgs = {
  filters?: InputMaybe<TypeOfEmploymentFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Question = {
  __typename?: 'Question';
  answer: Array<Maybe<QuestionAnswerDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<QuestionRelationResponseCollection>;
  name: Scalars['String'];
  question: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type QuestionLocalizationsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QuestionAnswerDynamicZone = ComponentAnswerFreeText | ComponentAnswerMultipleChoice | ComponentAnswerYesNo | Error;

export type QuestionEntity = {
  __typename?: 'QuestionEntity';
  attributes?: Maybe<Question>;
  id?: Maybe<Scalars['ID']>;
};

export type QuestionEntityResponse = {
  __typename?: 'QuestionEntityResponse';
  data?: Maybe<QuestionEntity>;
};

export type QuestionEntityResponseCollection = {
  __typename?: 'QuestionEntityResponseCollection';
  data: Array<QuestionEntity>;
  meta: ResponseCollectionMeta;
};

export type QuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<QuestionFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<QuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type QuestionInput = {
  answer?: InputMaybe<Array<Scalars['QuestionAnswerDynamicZoneInput']>>;
  name?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

export type QuestionRelationResponseCollection = {
  __typename?: 'QuestionRelationResponseCollection';
  data: Array<QuestionEntity>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Enum_Tag_Color>;
  createdAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Enum_Tag_Icon>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<TagRelationResponseCollection>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TagLocalizationsArgs = {
  filters?: InputMaybe<TagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TagEntity = {
  __typename?: 'TagEntity';
  attributes?: Maybe<Tag>;
  id?: Maybe<Scalars['ID']>;
};

export type TagEntityResponse = {
  __typename?: 'TagEntityResponse';
  data?: Maybe<TagEntity>;
};

export type TagEntityResponseCollection = {
  __typename?: 'TagEntityResponseCollection';
  data: Array<TagEntity>;
  meta: ResponseCollectionMeta;
};

export type TagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  icon?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<TagFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TagInput = {
  color?: InputMaybe<Enum_Tag_Color>;
  icon?: InputMaybe<Enum_Tag_Icon>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TagRelationResponseCollection = {
  __typename?: 'TagRelationResponseCollection';
  data: Array<TagEntity>;
};

export type TypeOfEmployment = {
  __typename?: 'TypeOfEmployment';
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<TypeOfEmploymentRelationResponseCollection>;
  name: Scalars['String'];
  offers?: Maybe<OfferRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TypeOfEmploymentLocalizationsArgs = {
  filters?: InputMaybe<TypeOfEmploymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TypeOfEmploymentOffersArgs = {
  filters?: InputMaybe<OfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TypeOfEmploymentEntity = {
  __typename?: 'TypeOfEmploymentEntity';
  attributes?: Maybe<TypeOfEmployment>;
  id?: Maybe<Scalars['ID']>;
};

export type TypeOfEmploymentEntityResponse = {
  __typename?: 'TypeOfEmploymentEntityResponse';
  data?: Maybe<TypeOfEmploymentEntity>;
};

export type TypeOfEmploymentEntityResponseCollection = {
  __typename?: 'TypeOfEmploymentEntityResponseCollection';
  data: Array<TypeOfEmploymentEntity>;
  meta: ResponseCollectionMeta;
};

export type TypeOfEmploymentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TypeOfEmploymentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<TypeOfEmploymentFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TypeOfEmploymentFiltersInput>;
  offers?: InputMaybe<OfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TypeOfEmploymentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TypeOfEmploymentInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TypeOfEmploymentRelationResponseCollection = {
  __typename?: 'TypeOfEmploymentRelationResponseCollection';
  data: Array<TypeOfEmploymentEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  blurImg?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  blurImg?: InputMaybe<StringFilterInput>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  blurImg?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstname?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lastname?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  phone?: InputMaybe<StringFilterInput>;
  position?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type UploadFileDataFragment = { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null };

export type GetTokenMutationVariables = Exact<{
  identifier: Scalars['String'];
  password: Scalars['String'];
}>;


export type GetTokenMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string } } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', username: string, firstname?: string | null, lastname?: string | null, position?: string | null, email?: string | null, phone?: string | null } | null };

export type GetOffersQueryVariables = Exact<{
  filters?: InputMaybe<OfferFiltersInput>;
  publicationState?: InputMaybe<PublicationState>;
  pagination?: InputMaybe<PaginationArg>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type GetOffersQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferEntityResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', publishedAt?: any | null, title: string, locale?: string | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name: string } | null } | null } | null, localizations?: { __typename?: 'OfferRelationResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', locale?: string | null } | null }> } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageCount: number, pageSize: number } } } | null };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOfferQuery = { __typename?: 'Query', offer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', publishedAt?: any | null, slug: string, title: string, description?: string | null, short_description?: string | null, withoutCV?: boolean | null, remote?: Enum_Offer_Remote | null, locale?: string | null, priority?: number | null, videoURL?: string | null, benefits?: Array<{ __typename?: 'ComponentMainBenefit', text: string, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null } | null } | null } | null> | null, images?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null }> } | null, location?: { __typename?: 'ComponentMainLocation', address?: { __typename?: 'ComponentMainAddress', street: string, locality: string, region?: string | null, postalCode: string, country: Enum_Componentmainaddress_Country } | null, coordinates?: { __typename?: 'ComponentMainCoordinates', lat: number, long: number } | null } | null, contactPerson: { __typename?: 'ComponentMainContactPerson', name: string, position?: string | null, email?: string | null, phone?: string | null, additional?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null } | null } | null }, seo: { __typename?: 'ComponentMainSeo', metaTitle: string, metaDescription?: string | null, keywords?: string | null, preventIndexing?: boolean | null, sharedImage: { __typename?: 'ComponentMainSharedImage', alt: string, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null } | null } } }, relatedOffers?: { __typename?: 'OfferRelationResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', title: string } | null }> } | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null } | null } | null, field_of_activities?: { __typename?: 'FieldOfActivityRelationResponseCollection', data: Array<{ __typename?: 'FieldOfActivityEntity', id?: string | null, attributes?: { __typename?: 'FieldOfActivity', key: string, name: string } | null }> } | null, type_of_employments?: { __typename?: 'TypeOfEmploymentRelationResponseCollection', data: Array<{ __typename?: 'TypeOfEmploymentEntity', id?: string | null, attributes?: { __typename?: 'TypeOfEmployment', key: string, name: string } | null }> } | null, employment_times?: { __typename?: 'EmploymentTimeRelationResponseCollection', data: Array<{ __typename?: 'EmploymentTimeEntity', id?: string | null, attributes?: { __typename?: 'EmploymentTime', key: string, name: string } | null }> } | null, questions?: { __typename?: 'QuestionRelationResponseCollection', data: Array<{ __typename?: 'QuestionEntity', id?: string | null, attributes?: { __typename?: 'Question', question: string } | null }> } | null, tags?: { __typename?: 'TagRelationResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: string | null, attributes?: { __typename?: 'Tag', key: string, name: string } | null }> } | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null } | null } | null, place?: { __typename?: 'PlaceEntityResponse', data?: { __typename?: 'PlaceEntity', id?: string | null } | null } | null, localizations?: { __typename?: 'OfferRelationResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', locale?: string | null, slug: string } | null }> } | null } | null } | null } | null };

export type CheckOfferSlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CheckOfferSlugQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferEntityResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null }> } | null };

export type CheckQuestionNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CheckQuestionNameQuery = { __typename?: 'Query', questions?: { __typename?: 'QuestionEntityResponseCollection', data: Array<{ __typename?: 'QuestionEntity', id?: string | null }> } | null };

export type CreateOfferMutationVariables = Exact<{
  data: OfferInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', createOffer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', slug: string } | null } | null } | null };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['ID'];
  data: OfferInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', slug: string } | null } | null } | null };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOfferMutation = { __typename?: 'Mutation', deleteOffer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null } | null } | null };

export type GetFilesQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetFilesQuery = { __typename?: 'Query', uploadFiles?: { __typename?: 'UploadFileEntityResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string, alternativeText?: string | null, formats?: any | null, ext?: string | null, width?: number | null, height?: number | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompanyEntityResponseCollection', data: Array<{ __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', key: string, name: string } | null }> } | null };

export type GetPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlacesQuery = { __typename?: 'Query', places?: { __typename?: 'PlaceEntityResponseCollection', data: Array<{ __typename?: 'PlaceEntity', id?: string | null, attributes?: { __typename?: 'Place', key: string, name: string } | null }> } | null };

export type GetActivityFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityFieldsQuery = { __typename?: 'Query', fieldOfActivities?: { __typename?: 'FieldOfActivityEntityResponseCollection', data: Array<{ __typename?: 'FieldOfActivityEntity', id?: string | null, attributes?: { __typename?: 'FieldOfActivity', key: string, name: string } | null }> } | null };

export type GetEmploymentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmploymentTypesQuery = { __typename?: 'Query', typeOfEmployments?: { __typename?: 'TypeOfEmploymentEntityResponseCollection', data: Array<{ __typename?: 'TypeOfEmploymentEntity', id?: string | null, attributes?: { __typename?: 'TypeOfEmployment', key: string, name: string } | null }> } | null };

export type GetEmploymentTimesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmploymentTimesQuery = { __typename?: 'Query', employmentTimes?: { __typename?: 'EmploymentTimeEntityResponseCollection', data: Array<{ __typename?: 'EmploymentTimeEntity', id?: string | null, attributes?: { __typename?: 'EmploymentTime', key: string, name: string } | null }> } | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagEntityResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: string | null, attributes?: { __typename?: 'Tag', key: string, name: string, color?: Enum_Tag_Color | null, icon?: Enum_Tag_Icon | null } | null }> } | null };

export type SearchOffersQueryVariables = Exact<{
  text: Scalars['String'];
  publicationState?: InputMaybe<PublicationState>;
}>;


export type SearchOffersQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferEntityResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', publishedAt?: any | null, title: string, locale?: string | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name: string } | null } | null } | null, localizations?: { __typename?: 'OfferRelationResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', locale?: string | null } | null }> } | null } | null }> } | null };

export type GetOfferQuestionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOfferQuestionsQuery = { __typename?: 'Query', offer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', title: string, questions?: { __typename?: 'QuestionRelationResponseCollection', data: Array<{ __typename?: 'QuestionEntity', id?: string | null }> } | null } | null } | null } | null };

export type GetQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionsQuery = { __typename?: 'Query', questions?: { __typename?: 'QuestionEntityResponseCollection', data: Array<{ __typename?: 'QuestionEntity', id?: string | null, attributes?: { __typename?: 'Question', name: string, question: string, answer: Array<{ __typename?: 'ComponentAnswerFreeText', id: string, required?: boolean | null } | { __typename?: 'ComponentAnswerMultipleChoice', id: string, onlyOneAnswer?: boolean | null, options: Array<{ __typename?: 'ComponentAnswerAnswerOption', id: string, answer: string, preferred?: boolean | null } | null> } | { __typename?: 'ComponentAnswerYesNo', id: string, preferred?: Enum_Componentansweryesno_Preferred | null } | { __typename?: 'Error', code: string } | null> } | null }> } | null };

export type CreateQuestionMutationVariables = Exact<{
  data: QuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion?: { __typename?: 'QuestionEntityResponse', data?: { __typename?: 'QuestionEntity', id?: string | null } | null } | null };

export type DeleteQuestionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion?: { __typename?: 'QuestionEntityResponse', data?: { __typename?: 'QuestionEntity', id?: string | null } | null } | null };

export type CreateOfferLocalizationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<OfferInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;


export type CreateOfferLocalizationMutation = { __typename?: 'Mutation', createOfferLocalization?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null } | null } | null };

export type GetOfferLocalizationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOfferLocalizationsQuery = { __typename?: 'Query', offer?: { __typename?: 'OfferEntityResponse', data?: { __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', locale?: string | null, slug: string, localizations?: { __typename?: 'OfferRelationResponseCollection', data: Array<{ __typename?: 'OfferEntity', id?: string | null, attributes?: { __typename?: 'Offer', locale?: string | null, slug: string } | null }> } | null } | null } | null } | null };

export const UploadFileDataFragmentDoc = gql`
    fragment UploadFileData on UploadFile {
  url
  name
  alternativeText
  formats
  ext
  width
  height
}
    `;
export const GetTokenDocument = gql`
    mutation GetToken($identifier: String!, $password: String!) {
  login(input: {identifier: $identifier, password: $password}) {
    jwt
    user {
      id
    }
  }
}
    `;
export type GetTokenMutationFn = Apollo.MutationFunction<GetTokenMutation, GetTokenMutationVariables>;

/**
 * __useGetTokenMutation__
 *
 * To run a mutation, you first call `useGetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTokenMutation, { data, loading, error }] = useGetTokenMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetTokenMutation, GetTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetTokenMutation, GetTokenMutationVariables>(GetTokenDocument, options);
      }
export type GetTokenMutationHookResult = ReturnType<typeof useGetTokenMutation>;
export type GetTokenMutationResult = Apollo.MutationResult<GetTokenMutation>;
export type GetTokenMutationOptions = Apollo.BaseMutationOptions<GetTokenMutation, GetTokenMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  me {
    username
    firstname
    lastname
    position
    email
    phone
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetOffersDocument = gql`
    query GetOffers($filters: OfferFiltersInput, $publicationState: PublicationState = PREVIEW, $pagination: PaginationArg = {}, $locale: I18NLocaleCode = "de") {
  offers(
    filters: $filters
    publicationState: $publicationState
    pagination: $pagination
    locale: $locale
    sort: "updatedAt:desc"
  ) {
    data {
      id
      attributes {
        publishedAt
        title
        locale
        company {
          data {
            id
            attributes {
              name
            }
          }
        }
        localizations(publicationState: PREVIEW) {
          data {
            id
            attributes {
              locale
            }
          }
        }
      }
    }
    meta {
      pagination {
        total
        page
        pageCount
        pageSize
      }
    }
  }
}
    `;

/**
 * __useGetOffersQuery__
 *
 * To run a query within a React component, call `useGetOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      publicationState: // value for 'publicationState'
 *      pagination: // value for 'pagination'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetOffersQuery(baseOptions?: Apollo.QueryHookOptions<GetOffersQuery, GetOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOffersQuery, GetOffersQueryVariables>(GetOffersDocument, options);
      }
export function useGetOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOffersQuery, GetOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOffersQuery, GetOffersQueryVariables>(GetOffersDocument, options);
        }
export type GetOffersQueryHookResult = ReturnType<typeof useGetOffersQuery>;
export type GetOffersLazyQueryHookResult = ReturnType<typeof useGetOffersLazyQuery>;
export type GetOffersQueryResult = Apollo.QueryResult<GetOffersQuery, GetOffersQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($id: ID!) {
  offer(id: $id) {
    data {
      id
      attributes {
        publishedAt
        slug
        title
        description
        benefits {
          text
          description
          icon {
            data {
              id
              attributes {
                ...UploadFileData
              }
            }
          }
        }
        images {
          data {
            id
            attributes {
              ...UploadFileData
            }
          }
        }
        location {
          address {
            street
            locality
            region
            postalCode
            country
          }
          coordinates {
            lat
            long
          }
        }
        contactPerson {
          name
          position
          email
          phone
          additional
          image {
            data {
              id
              attributes {
                ...UploadFileData
              }
            }
          }
        }
        seo {
          metaTitle
          metaDescription
          sharedImage {
            media {
              data {
                id
                attributes {
                  ...UploadFileData
                }
              }
            }
            alt
          }
          keywords
          preventIndexing
        }
        relatedOffers {
          data {
            id
            attributes {
              title
            }
          }
        }
        short_description
        mainImage {
          data {
            id
            attributes {
              ...UploadFileData
            }
          }
        }
        field_of_activities {
          data {
            id
            attributes {
              key
              name
            }
          }
        }
        type_of_employments {
          data {
            id
            attributes {
              key
              name
            }
          }
        }
        employment_times {
          data {
            id
            attributes {
              key
              name
            }
          }
        }
        questions {
          data {
            id
            attributes {
              question
            }
          }
        }
        withoutCV
        remote
        tags {
          data {
            id
            attributes {
              key
              name
            }
          }
        }
        company {
          data {
            id
          }
        }
        place {
          data {
            id
          }
        }
        locale
        priority
        videoURL
        localizations(publicationState: PREVIEW) {
          data {
            id
            attributes {
              locale
              slug
            }
          }
        }
      }
    }
  }
}
    ${UploadFileDataFragmentDoc}`;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const CheckOfferSlugDocument = gql`
    query CheckOfferSlug($slug: String!) {
  offers(filters: {slug: {eq: $slug}}, publicationState: PREVIEW, locale: "all") {
    data {
      id
    }
  }
}
    `;

/**
 * __useCheckOfferSlugQuery__
 *
 * To run a query within a React component, call `useCheckOfferSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOfferSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOfferSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCheckOfferSlugQuery(baseOptions: Apollo.QueryHookOptions<CheckOfferSlugQuery, CheckOfferSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckOfferSlugQuery, CheckOfferSlugQueryVariables>(CheckOfferSlugDocument, options);
      }
export function useCheckOfferSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOfferSlugQuery, CheckOfferSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckOfferSlugQuery, CheckOfferSlugQueryVariables>(CheckOfferSlugDocument, options);
        }
export type CheckOfferSlugQueryHookResult = ReturnType<typeof useCheckOfferSlugQuery>;
export type CheckOfferSlugLazyQueryHookResult = ReturnType<typeof useCheckOfferSlugLazyQuery>;
export type CheckOfferSlugQueryResult = Apollo.QueryResult<CheckOfferSlugQuery, CheckOfferSlugQueryVariables>;
export const CheckQuestionNameDocument = gql`
    query CheckQuestionName($name: String!) {
  questions(filters: {name: {eq: $name}}) {
    data {
      id
    }
  }
}
    `;

/**
 * __useCheckQuestionNameQuery__
 *
 * To run a query within a React component, call `useCheckQuestionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckQuestionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckQuestionNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckQuestionNameQuery(baseOptions: Apollo.QueryHookOptions<CheckQuestionNameQuery, CheckQuestionNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckQuestionNameQuery, CheckQuestionNameQueryVariables>(CheckQuestionNameDocument, options);
      }
export function useCheckQuestionNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckQuestionNameQuery, CheckQuestionNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckQuestionNameQuery, CheckQuestionNameQueryVariables>(CheckQuestionNameDocument, options);
        }
export type CheckQuestionNameQueryHookResult = ReturnType<typeof useCheckQuestionNameQuery>;
export type CheckQuestionNameLazyQueryHookResult = ReturnType<typeof useCheckQuestionNameLazyQuery>;
export type CheckQuestionNameQueryResult = Apollo.QueryResult<CheckQuestionNameQuery, CheckQuestionNameQueryVariables>;
export const CreateOfferDocument = gql`
    mutation CreateOffer($data: OfferInput!, $locale: I18NLocaleCode = "de") {
  createOffer(data: $data, locale: $locale) {
    data {
      id
      attributes {
        slug
      }
    }
  }
}
    `;
export type CreateOfferMutationFn = Apollo.MutationFunction<CreateOfferMutation, CreateOfferMutationVariables>;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      data: // value for 'data'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferMutation, CreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(CreateOfferDocument, options);
      }
export type CreateOfferMutationHookResult = ReturnType<typeof useCreateOfferMutation>;
export type CreateOfferMutationResult = Apollo.MutationResult<CreateOfferMutation>;
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables>;
export const UpdateOfferDocument = gql`
    mutation UpdateOffer($id: ID!, $data: OfferInput!, $locale: I18NLocaleCode = "de") {
  updateOffer(id: $id, data: $data, locale: $locale) {
    data {
      id
      attributes {
        slug
      }
    }
  }
}
    `;
export type UpdateOfferMutationFn = Apollo.MutationFunction<UpdateOfferMutation, UpdateOfferMutationVariables>;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutation, UpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
      }
export type UpdateOfferMutationHookResult = ReturnType<typeof useUpdateOfferMutation>;
export type UpdateOfferMutationResult = Apollo.MutationResult<UpdateOfferMutation>;
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const DeleteOfferDocument = gql`
    mutation DeleteOffer($id: ID!) {
  deleteOffer(id: $id) {
    data {
      id
    }
  }
}
    `;
export type DeleteOfferMutationFn = Apollo.MutationFunction<DeleteOfferMutation, DeleteOfferMutationVariables>;

/**
 * __useDeleteOfferMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferMutation, { data, loading, error }] = useDeleteOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferMutation, DeleteOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferMutation, DeleteOfferMutationVariables>(DeleteOfferDocument, options);
      }
export type DeleteOfferMutationHookResult = ReturnType<typeof useDeleteOfferMutation>;
export type DeleteOfferMutationResult = Apollo.MutationResult<DeleteOfferMutation>;
export type DeleteOfferMutationOptions = Apollo.BaseMutationOptions<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const GetFilesDocument = gql`
    query GetFiles($ids: [ID], $pagination: PaginationArg = {page: 1, pageSize: 10}) {
  uploadFiles(
    filters: {id: {in: $ids}}
    pagination: $pagination
    sort: "createdAt:desc"
  ) {
    data {
      id
      attributes {
        ...UploadFileData
      }
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    ${UploadFileDataFragmentDoc}`;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetCompaniesDocument = gql`
    query GetCompanies {
  companies(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
      }
    }
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetPlacesDocument = gql`
    query GetPlaces {
  places(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
      }
    }
  }
}
    `;

/**
 * __useGetPlacesQuery__
 *
 * To run a query within a React component, call `useGetPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlacesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
      }
export function useGetPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export type GetPlacesQueryHookResult = ReturnType<typeof useGetPlacesQuery>;
export type GetPlacesLazyQueryHookResult = ReturnType<typeof useGetPlacesLazyQuery>;
export type GetPlacesQueryResult = Apollo.QueryResult<GetPlacesQuery, GetPlacesQueryVariables>;
export const GetActivityFieldsDocument = gql`
    query GetActivityFields {
  fieldOfActivities(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
      }
    }
  }
}
    `;

/**
 * __useGetActivityFieldsQuery__
 *
 * To run a query within a React component, call `useGetActivityFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityFieldsQuery, GetActivityFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityFieldsQuery, GetActivityFieldsQueryVariables>(GetActivityFieldsDocument, options);
      }
export function useGetActivityFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityFieldsQuery, GetActivityFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityFieldsQuery, GetActivityFieldsQueryVariables>(GetActivityFieldsDocument, options);
        }
export type GetActivityFieldsQueryHookResult = ReturnType<typeof useGetActivityFieldsQuery>;
export type GetActivityFieldsLazyQueryHookResult = ReturnType<typeof useGetActivityFieldsLazyQuery>;
export type GetActivityFieldsQueryResult = Apollo.QueryResult<GetActivityFieldsQuery, GetActivityFieldsQueryVariables>;
export const GetEmploymentTypesDocument = gql`
    query GetEmploymentTypes {
  typeOfEmployments(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
      }
    }
  }
}
    `;

/**
 * __useGetEmploymentTypesQuery__
 *
 * To run a query within a React component, call `useGetEmploymentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmploymentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmploymentTypesQuery, GetEmploymentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmploymentTypesQuery, GetEmploymentTypesQueryVariables>(GetEmploymentTypesDocument, options);
      }
export function useGetEmploymentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmploymentTypesQuery, GetEmploymentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmploymentTypesQuery, GetEmploymentTypesQueryVariables>(GetEmploymentTypesDocument, options);
        }
export type GetEmploymentTypesQueryHookResult = ReturnType<typeof useGetEmploymentTypesQuery>;
export type GetEmploymentTypesLazyQueryHookResult = ReturnType<typeof useGetEmploymentTypesLazyQuery>;
export type GetEmploymentTypesQueryResult = Apollo.QueryResult<GetEmploymentTypesQuery, GetEmploymentTypesQueryVariables>;
export const GetEmploymentTimesDocument = gql`
    query GetEmploymentTimes {
  employmentTimes(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
      }
    }
  }
}
    `;

/**
 * __useGetEmploymentTimesQuery__
 *
 * To run a query within a React component, call `useGetEmploymentTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmploymentTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmploymentTimesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmploymentTimesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmploymentTimesQuery, GetEmploymentTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmploymentTimesQuery, GetEmploymentTimesQueryVariables>(GetEmploymentTimesDocument, options);
      }
export function useGetEmploymentTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmploymentTimesQuery, GetEmploymentTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmploymentTimesQuery, GetEmploymentTimesQueryVariables>(GetEmploymentTimesDocument, options);
        }
export type GetEmploymentTimesQueryHookResult = ReturnType<typeof useGetEmploymentTimesQuery>;
export type GetEmploymentTimesLazyQueryHookResult = ReturnType<typeof useGetEmploymentTimesLazyQuery>;
export type GetEmploymentTimesQueryResult = Apollo.QueryResult<GetEmploymentTimesQuery, GetEmploymentTimesQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  tags(pagination: {limit: -1}) {
    data {
      id
      attributes {
        key
        name
        color
        icon
      }
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const SearchOffersDocument = gql`
    query SearchOffers($text: String!, $publicationState: PublicationState = LIVE) {
  offers(
    filters: {title: {containsi: $text}}
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        publishedAt
        title
        locale
        company {
          data {
            id
            attributes {
              name
            }
          }
        }
        localizations(publicationState: PREVIEW) {
          data {
            id
            attributes {
              locale
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchOffersQuery__
 *
 * To run a query within a React component, call `useSearchOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOffersQuery({
 *   variables: {
 *      text: // value for 'text'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useSearchOffersQuery(baseOptions: Apollo.QueryHookOptions<SearchOffersQuery, SearchOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, options);
      }
export function useSearchOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOffersQuery, SearchOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, options);
        }
export type SearchOffersQueryHookResult = ReturnType<typeof useSearchOffersQuery>;
export type SearchOffersLazyQueryHookResult = ReturnType<typeof useSearchOffersLazyQuery>;
export type SearchOffersQueryResult = Apollo.QueryResult<SearchOffersQuery, SearchOffersQueryVariables>;
export const GetOfferQuestionsDocument = gql`
    query GetOfferQuestions($id: ID!) {
  offer(id: $id) {
    data {
      id
      attributes {
        title
        questions {
          data {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferQuestionsQuery__
 *
 * To run a query within a React component, call `useGetOfferQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuestionsQuery, GetOfferQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuestionsQuery, GetOfferQuestionsQueryVariables>(GetOfferQuestionsDocument, options);
      }
export function useGetOfferQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuestionsQuery, GetOfferQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuestionsQuery, GetOfferQuestionsQueryVariables>(GetOfferQuestionsDocument, options);
        }
export type GetOfferQuestionsQueryHookResult = ReturnType<typeof useGetOfferQuestionsQuery>;
export type GetOfferQuestionsLazyQueryHookResult = ReturnType<typeof useGetOfferQuestionsLazyQuery>;
export type GetOfferQuestionsQueryResult = Apollo.QueryResult<GetOfferQuestionsQuery, GetOfferQuestionsQueryVariables>;
export const GetQuestionsDocument = gql`
    query GetQuestions {
  questions(pagination: {limit: -1}) {
    data {
      id
      attributes {
        name
        question
        answer {
          ... on ComponentAnswerYesNo {
            id
            preferred
          }
          ... on ComponentAnswerMultipleChoice {
            id
            onlyOneAnswer
            options {
              id
              answer
              preferred
            }
          }
          ... on ComponentAnswerFreeText {
            id
            required
          }
          ... on Error {
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($data: QuestionInput!) {
  createQuestion(data: $data) {
    data {
      id
    }
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation DeleteQuestion($id: ID!) {
  deleteQuestion(id: $id) {
    data {
      id
    }
  }
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const CreateOfferLocalizationDocument = gql`
    mutation CreateOfferLocalization($id: ID, $data: OfferInput, $locale: I18NLocaleCode) {
  createOfferLocalization(id: $id, data: $data, locale: $locale) {
    data {
      id
    }
  }
}
    `;
export type CreateOfferLocalizationMutationFn = Apollo.MutationFunction<CreateOfferLocalizationMutation, CreateOfferLocalizationMutationVariables>;

/**
 * __useCreateOfferLocalizationMutation__
 *
 * To run a mutation, you first call `useCreateOfferLocalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferLocalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferLocalizationMutation, { data, loading, error }] = useCreateOfferLocalizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateOfferLocalizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferLocalizationMutation, CreateOfferLocalizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferLocalizationMutation, CreateOfferLocalizationMutationVariables>(CreateOfferLocalizationDocument, options);
      }
export type CreateOfferLocalizationMutationHookResult = ReturnType<typeof useCreateOfferLocalizationMutation>;
export type CreateOfferLocalizationMutationResult = Apollo.MutationResult<CreateOfferLocalizationMutation>;
export type CreateOfferLocalizationMutationOptions = Apollo.BaseMutationOptions<CreateOfferLocalizationMutation, CreateOfferLocalizationMutationVariables>;
export const GetOfferLocalizationsDocument = gql`
    query GetOfferLocalizations($id: ID!) {
  offer(id: $id) {
    data {
      id
      attributes {
        locale
        slug
        localizations(publicationState: PREVIEW) {
          data {
            id
            attributes {
              locale
              slug
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferLocalizationsQuery__
 *
 * To run a query within a React component, call `useGetOfferLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<GetOfferLocalizationsQuery, GetOfferLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferLocalizationsQuery, GetOfferLocalizationsQueryVariables>(GetOfferLocalizationsDocument, options);
      }
export function useGetOfferLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferLocalizationsQuery, GetOfferLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferLocalizationsQuery, GetOfferLocalizationsQueryVariables>(GetOfferLocalizationsDocument, options);
        }
export type GetOfferLocalizationsQueryHookResult = ReturnType<typeof useGetOfferLocalizationsQuery>;
export type GetOfferLocalizationsLazyQueryHookResult = ReturnType<typeof useGetOfferLocalizationsLazyQuery>;
export type GetOfferLocalizationsQueryResult = Apollo.QueryResult<GetOfferLocalizationsQuery, GetOfferLocalizationsQueryVariables>;